import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProgramaAcademicoService } from '../../_services/programa-academico.service';

@Component({
  selector: 'app-programa-modal-eliminar',
  templateUrl: './programa-modal-eliminar.component.html',
  styleUrls: ['./programa-modal-eliminar.component.scss']
})
export class ProgramaModalEliminarComponent implements OnInit {

  public numPeriodosSeleccionados: number = 0;
  public boolIsArray: boolean = false;
  public claveProgramas: string = '';

  constructor(public dialogRef: MatDialogRef<ProgramaModalEliminarComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: MatSnackBar,
    private programaAcademicoService: ProgramaAcademicoService) { }

  ngOnInit(): void {
    this.validarDataRecibida();
  }

  public validarDataRecibida() {
    this.boolIsArray = Array.isArray(this.data);
    if (this.boolIsArray) {
      this.numPeriodosSeleccionados = this.data.length;
    }
  }

  public eliminarPrograma() {
    if (this.boolIsArray) {
      let arrayClaves = this.data.map(p => (p.programaId.toString()));
      this.claveProgramas = arrayClaves.toString();
    } else {
      this.claveProgramas = this.data.programaId.toString();
    }
    this.programaAcademicoService.eliminarPrograma(this.claveProgramas).subscribe(
      eliminado => {
        if (eliminado) {
          this.snackBar.open("Se ha eliminado la información.", "OK", { duration: 5000 });
          this.programaAcademicoService.invocarMetodo();
          this.dialogRef.close(this.data);
        } else {
          this.snackBar.open("Ha ocurrido un error al eliminar el programa. Por favor, intente de nuevo más tarde.", "OK", { duration: 5000 });
        }
      },
      error => {
        console.log("error", error);
        this.snackBar.open("Ha ocurrido un error al eliminar el programa. Por favor, intente de nuevo más tarde.", "OK", { duration: 5000 });
      }
    );
  }

}
